<div class="dialog-wrapper">
  <div class="dialog-header">
    <div class="dialog-header-title">
      <h3>{{ 'sube_documento' | translate:_transParam }}</h3>
    </div>
  </div>
  <input #fileInput type="file" hidden multiple (change)="loadLocalFile($event)" [accept]="extensions" />
  <div #container class="dialog-content" (dragenter)="onDragEnter()" (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)" (dragover)="onDragOver($event)">
    <div *ngIf="isCreate && minPage !== 1">
      <p class="subTitleDialog" [innerHTML]="'files_upload.text.header' | translate: {minPage: minPage}">
    </div>
    <div class="uploadArea">
      <div class="dialog-content-left">
        <a [matTooltip]="'desde_pc' | translate:_transParam" matTooltipPosition="right" (click)="fileInput.click()">
          <mat-icon [style.color]="'primary'|colors" [color]="'material'|colors"
            class="local__icon">cloud_upload</mat-icon>
        </a>
        <a [matTooltip]="'desde_drive' | translate:_transParam" matTooltipPosition="right" (click)="loadGoogleDrive()">
          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="36px" height="36px" viewBox="0,0,256,256">
            <g fill="#0f3e4d" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
              stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
              font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal">
              <g transform="scale(5.33333,5.33333)">
                <path
                  d="M44.52,28h-13.53l-13.28,-23h11.221c1.429,0 2.749,0.762 3.464,2zM44.32,31l-5.766,9.998c-0.714,1.239 -2.035,2.002 -3.465,2.002h-23.379l6.93,-12zM22.21,18.8l-13.06,22.62l-5.766,-9.99c-0.714,-1.238 -0.714,-2.762 0,-4l11.906,-20.62z">
                </path>
              </g>
            </g>
          </svg>
        </a>
        <a [matTooltip]="(allowDropbox ? 'desde_dropbox' : 'dropbox_no_disponible') | translate:_transParam"
          matTooltipPosition="right" (click)="loadDropbox()">
          <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="36px" height="36px" viewBox="0,0,256,256">
            <g fill="#0f3e4d" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
              stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
              font-family="none" font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal">
              <g transform="scale(10.66667,10.66667)">
                <path
                  d="M8.09375,2l-6.09375,4l4.1875,3.1875l5.8125,-3.78125zM12,5.40625l6.09375,3.59375l3.90625,-3.1875l-5.90625,-3.8125zM18.09375,9l-6.09375,3.90625l4,3.09375l6,-3.59375zM12,12.90625l-5.8125,-3.71875l-4.1875,3.21875l6.09375,3.59375zM12,14.5l-4,3l-2,-1.1875v1.6875l6,4l6,-3.90625v-1.78125l-2,1.1875z">
                </path>
              </g>
            </g>
          </svg>
        </a>
      </div>
      <div>
        <div class="dialog-content-right">
          <h3>{{ 'arrastra_documento' | translate:_transParam }}</h3>
          <p class="rightContent">{{ 'arrastra_suelta_documento' | translate:_transParam }}</p>
          <p *ngIf="extensions" class="rightContent">{{ 'allowed_extensions' | translate : { valueParam: extensions } }}
          </p>
        </div>
      </div>
    </div>
    <div class="warning" *ngIf="!isValid">
      <mat-icon class="warning_warningIcon">warning</mat-icon>
      <p class="warning_warningText" [innerHTML]="'files_upload.text.warning' | translate: {minPage: minPage}"></p>
    </div>
  </div>
  <div class="buttonSettings">
    <signaturit-button text="{{ 'files_upload.text.cancel' | translate }}" type="ghost" size="md"
      mat-dialog-close></signaturit-button>
    <signaturit-button text="{{ 'files_upload.text.confirm' | translate }}" type="secondary" size="md"
      (click)="fileInput.click()"></signaturit-button>
  </div>
</div>
